import {alertMessage} from "../messages";

export const comparemessage = ($selector, $message, $title) => {
    alertMessage($title, $message);
}